import { lazy, Suspense, useEffect, useLayoutEffect, useRef } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import webview from '@adapter/webview';

import { initHoistSDK } from 'src/utils/adapter/hoist';
import { getDeviceUUID, getSessionId, getWebviewDeviceID } from 'src/utils/storage';

import { FlowNavigator } from './pages/FlowNavigator';
import NotFoundPage from './pages/NotFoundPage';
import { getDomainConfig } from './utils/config/domainConfig';
import { setDeviceContext } from './utils/adapter/gobbler';
import { InjectUserData } from './components/InjectUserData';
import OnboardingProvider from './OnboardingProvider';

const FnoOnboardingPageLayout = lazy(() => import('./screens/FnoOnboarding'));
const ResetJourneyView = lazy(() => import('./screens/ResetJourney'));

function App() {
    const { apiBaseUrl, hoistApiKey } = getDomainConfig(window.location.hostname);
    const hoistInitializedRef = useRef(false);
    const WV = webview();
    const deviceId = WV.isActive ? getWebviewDeviceID() || getDeviceUUID() || '' : getDeviceUUID() ?? '';

    useLayoutEffect(() => {
        if (!hoistInitializedRef.current) {
            initHoistSDK(getSessionId(), apiBaseUrl, hoistApiKey);
            hoistInitializedRef.current = true;
        }
    }, [apiBaseUrl, hoistApiKey]);

    useEffect(() => {
        setDeviceContext(deviceId);
    }, []);

    return (
        <BrowserRouter>
            <InjectUserData />
            <OnboardingProvider>
                <Suspense fallback={null}>
                    <Routes>
                        <Route path="/" element={<Navigate to="/onboarding" replace />} />
                        <Route path="/onboarding" element={<FlowNavigator />} />
                        <Route path="/onboarding/futures-and-options" element={<FnoOnboardingPageLayout />} />
                        <Route path="/onboarding/fno" element={<FnoOnboardingPageLayout />} />
                        <Route path="/onboarding/cosmos" element={<FlowNavigator />} />
                        <Route path="/onboarding/nri" element={<FlowNavigator />} />
                        <Route path="/onboarding/:stepId" element={<FlowNavigator />} />
                        <Route path="/onboarding/reset-journey" element={<ResetJourneyView />} />
                        <Route path="*" element={<NotFoundPage />} />
                    </Routes>
                </Suspense>
            </OnboardingProvider>
        </BrowserRouter>
    );
}

export default App;
